export enum SequenceFlowPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    ConditionExpression = "ConditionExpression",
    Default = "Default",
    billCreationType = "billCreationType",
    billRelationType = "billRelationType",
    aifAutoProcessCode = "aifAutoProcessCode",
    aifPushProcessCode = "aifPushProcessCode",
    aifPullProcessCode = "aifPullProcessCode",
}